import KMaskedTextField from "./KMaskedTextField";

export default KMaskedTextField.extend( {
	name: "KCurrencyField",

	props: {
		maskOptions: {
			...KMaskedTextField.options.props.maskOptions,
			default: () => ( {
				mask: Number,
				scale: 2,
				signed: true,
				thousandsSeparator: ",",
				padFractionalZeros: false,
				normalizeZeros: false,
				radix: ".",
				mapToRadix: [ "." ]
			} ),
			required: false
		},

		prependIcon: {
			...KMaskedTextField.options.props.prependIcon,
			default: "attach_money"
		}
	}
} );
